module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_editor') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addTemplates
    }
  }, [_vm._v("新增运费模板")])], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "卖家承担运费",
      "name": "first"
    }
  }, [_c('buyerTemplates', {
    ref: "buyerTemplates",
    attrs: {
      "get-status": _vm.buyerTemplates
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "按重量运费模板",
      "name": "second"
    }
  }, [_c('weightTemplates', {
    attrs: {
      "get-status": _vm.weightTemplates
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "按件数运费模板",
      "name": "third"
    }
  }, [_c('numberTemplates', {
    attrs: {
      "get-status": _vm.numberTemplates
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "按金额运费模板",
      "name": "fourth"
    }
  }, [_c('priceTemplates', {
    attrs: {
      "get-status": _vm.priceTemplates
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "按体积运费模板",
      "name": "fifth"
    }
  }, [_c('volumeTemplates', {
    attrs: {
      "get-status": _vm.volumeTemplates
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2a84a19b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a84a19b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/trade/shipping/templates.vue
// module id = 2563
// module chunks = 0